firebird.controller('meetingEndedThankYouCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'attendeeService',
    'cfpLoadingBar',
    'helperService',
    'meetingService',
    'brandingService',
    'uniteNotificationService',
    'camaroService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        attendeeService,
        cfpLoadingBar,
        helperService,
        meetingService,
        brandingService,
        uniteNotificationService,
        camaroService
    ) {
        const self = this;

        let redirectTimeoutPromise = null;

        self.init = init;
        self.shouldRedirectToAccountManager = shouldRedirectToAccountManager; // exposed only for testing
        self.redirectToAccountManagerAfterDelay = redirectToAccountManagerAfterDelay;
        self.getAppLogoURL = meetingService.getAppLogoURL;
        self.showRedirectMessage = showRedirectMessage;

        $scope.$on('callstat-survey-completed', onCallstatSurveyCompleted);
        $scope.$on('$destroy', onDestroy);

        init();

        ////////////////////////

        function init() {
            //jquery hack for hiding the loading spinner during XHR requests
            $window.$('body > #loading-bar-spinner').hide();

            // Handle redirects for different scenarios after meeting ends
            if (helperService.isUniteWeb()) {
                notifyUniteWebAndCloseWindow();
            } else if (helperService.isUniteApplication()) {
                camaroService.closeWindow();
            } else if (helperService.isStartedFromWebinarDashboard()) {
                $window.location.href = helperService.getWebinarDashboardRedirectUrl();
            } else {
                self.redirectToAccountManagerAfterDelay();
            }

            // Exit compact mode if meeting ends while in compact mode layout
            $rootScope.$broadcast('enable-compact-mode', false);
        }

        function onCallstatSurveyCompleted(e, data) {
            if (helperService.isUniteApplication()) {
                camaroService.closeWindowForced();
            } else if (helperService.isUniteWeb()) {
                notifyUniteWebAndCloseWindow();
            } else if (data && !data.hostIssuedRedirect) {
                self.redirectToAccountManagerAfterDelay();
            }
        }

        function redirectToAccountManagerAfterDelay() {
            // Cancel any existing redirect timeout to prevent multiple redirects
            if (redirectTimeoutPromise) {
                $timeout.cancel(redirectTimeoutPromise);
                redirectTimeoutPromise = null;
            }

            if (self.shouldRedirectToAccountManager()) {
                cfpLoadingBar.start();
                redirectTimeoutPromise = $timeout(() => {
                    redirectTimeoutPromise = null;
                    cfpLoadingBar.complete();
                    $window.location.href = helperService.getAccountManagerRedirectUrl();
                }, 5000);
            } else {
                // Complete loading bar if no redirect is happening
                cfpLoadingBar.complete();
            }
        }

        function onDestroy() {
            // Cancel pending redirect timeout to prevent late redirects and UI side effects
            if (redirectTimeoutPromise) {
                $timeout.cancel(redirectTimeoutPromise);
                redirectTimeoutPromise = null;

                // Ensure the loading bar is not left in a started state during teardown
                cfpLoadingBar.complete();
            }
        }

        function notifyUniteWebAndCloseWindow() {
            uniteNotificationService.sendMeetingEndedEvent();

            // This popup was opened by Unite Web via window.open, so it is allowed
            // to close itself. Ensure no beforeunload confirmation blocks the close,
            // and give the postMessage a moment to be delivered to the opener.
            $rootScope.$broadcast('removeOnBeforeUnloadConfirmation');
            $timeout(function () {
                $window.close();
            }, 500);
        }

        function shouldRedirectToAccountManager() {
            // Cause we can't detect if meeting was started from AccountManager reliably
            // we are checking in reverse - exclude all other known cases
            // TODO: detect isFromAccountManager reliably, e.g. via cookie or sticky optional URL parameter
            var isStartedFromAccountManager =
                !helperService.isUniteApplication() &&
                !helperService.isUniteWeb() &&
                !helperService.isMobile() &&
                !helperService.isElectron() &&
                !helperService.isStartedFromWebinarDashboard();

            var isHostUser = attendeeService.getIsHost() === true;

            return isHostUser && brandingService.isAccountManagerAvailable() && isStartedFromAccountManager;
        }

        function showRedirectMessage() {
            return attendeeService.getIsHost() && isAccountManagerAvailable();
        }

        function isAccountManagerAvailable() {
            return (
                !helperService.isUniteApplication() &&
                !helperService.isUniteWeb() &&
                brandingService.isAccountManagerAvailable()
            );
        }
    }
]);
